module.exports = __webpack_public_path__ + "img/soft.3b2f8985.svg";